import { FC } from "react"
import { RateTableConfigDetails } from "../../../../../../types"
import RateTableGeneral from "./sections/general"
import RateTableTerms from "./sections/terms"
import RateTablePresets from "./sections/presets"
import RateTableCta from "./sections/cta"
import RateTableAdvanced from "./sections/advanced"

interface Props {
  values: RateTableConfigDetails
  tab: string
  setFormField: (name: string, value: any) => void
}

const ManageRateTableFormContent: FC<Props> = ({
  values,
  tab,
  setFormField
}) => {
  const setDetailsField = (field: string, value: any) => {
    setFormField("details", { ...values.details, [field]: value })
  }

  const removeDetailsField = (field: string) => {
    const { [field]: _, ...rest } = values.details as Record<string, any>
    setFormField("details", rest)
  }

  return (
    <>
      {tab === "general" && (
        <RateTableGeneral
          values={values}
          setDetailsField={setDetailsField}
          removeDetailsField={removeDetailsField}
        />
      )}
      {tab === "terms" && (
        <RateTableTerms values={values} setDetailsField={setDetailsField} />
      )}
      {tab === "presets" && (
        <RateTablePresets values={values} setDetailsField={setDetailsField} />
      )}
      {tab === "cta" && (
        <RateTableCta values={values} setDetailsField={setDetailsField} />
      )}
      {tab === "advanced" && (
        <RateTableAdvanced values={values} setDetailsField={setDetailsField} />
      )}
    </>
  )
}

export default ManageRateTableFormContent
